import { motion } from 'motion/react';
import { useEffect, useRef } from 'react';

interface TimeSlotProps {
	containerRef?: React.RefObject<HTMLDivElement>;
	index: number;
	label: string;
	onClick: () => void;
	selected: boolean;
}

export default function TimeSlot({ containerRef, index, label, onClick, selected = false }: TimeSlotProps) {
	const buttonRef = useRef<HTMLButtonElement>(null);
	const classNames = ['time-slot'];
	if (selected) classNames.push('time-slot--selected');

	const transition = {
		duration: 0.25,
		delay: 0.2 * index,
		animation: { ease: 'easeInOut' },
	};

	const variants = {
		hidden: { transform: 'translateY(-.5rem)', opacity: 0 },
		visible: { transform: 'translateY(0)', opacity: 1 },
	};

	useEffect(() => {
		if (selected && buttonRef.current && containerRef?.current) {
			// Calculate position relative to scrollable container
			const containerRect = containerRef.current.getBoundingClientRect();
			const buttonRect = buttonRef.current.getBoundingClientRect();
			const relativeTop = buttonRect.top - containerRect.top + containerRef.current.scrollTop;

			// Scroll the container to show the button at the top
			containerRef.current.scrollTo({
				top: relativeTop,
				behavior: 'smooth',
			});
		}
	}, [selected, containerRef]);

	return (
		<motion.li
			className={classNames.join(' ')}
			onClick={onClick}
			data-color-scheme={selected ? 'highlight' : undefined}
			initial="hidden"
			animate="visible"
			exit="hidden"
			variants={variants}
			transition={transition}
		>
			<button ref={buttonRef} type="button">
				<span className="radio" aria-hidden="true" />
				{label}
			</button>
		</motion.li>
	);
}
